var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25294 5.71099C2.55665 5.39373 3.0139 5.35698 3.27422 5.62893L7.20223 9.73222L7.75216 9.15775L4.08615 5.32817C3.78244 5.0109 3.78244 4.49651 4.08615 4.17925C4.38986 3.86198 4.88228 3.86198 5.18599 4.17924L8.852 8.00883L9.40191 7.43437L5.47391 3.33108C5.21358 3.05914 5.24875 2.58149 5.55247 2.26423C5.85618 1.94696 6.31342 1.91022 6.57375 2.18216L10.5018 6.28545C11.5267 7.35615 11.6869 8.98811 10.9824 10.2343L20.9179 20.6131C21.2216 20.9304 21.2216 21.4448 20.9179 21.762C20.6142 22.0793 20.1218 22.0793 19.818 21.762L9.88255 11.3832C8.68962 12.1192 7.12736 11.9518 6.10239 10.8811L2.17438 6.77785C1.91406 6.50591 1.94923 6.02826 2.25294 5.71099Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3144 11.1385L14.4142 12.2874L15.4462 11.207C15.476 11.1758 15.5028 11.1428 15.5267 11.1083C16.7943 11.7737 18.6244 11.3338 19.9646 9.93375C21.5492 8.27845 22.7096 5.00863 21.4948 3.73957C20.2799 2.4705 17.1498 3.68277 15.5652 5.33807C14.225 6.73808 13.8039 8.64983 14.4409 9.97401C14.4074 9.99931 14.3754 10.0277 14.3452 10.0593L13.3144 11.1385Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7508 13.8222L11.8507 14.9711L5.36435 21.7614C5.06097 22.079 4.56855 22.0796 4.26451 21.7627C3.96047 21.4457 3.95994 20.9314 4.26333 20.6137L10.7508 13.8222Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.6345d2343d6fdf72d808901a2dd9f37c.svg";
export { ForwardRef as ReactComponent };